import { render, staticRenderFns } from "./EditingTools.vue?vue&type=template&id=56e27f42&scoped=true&lang=html&"
import script from "./EditingTools.vue?vue&type=script&lang=js&"
export * from "./EditingTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e27f42",
  null
  
)

export default component.exports